const mutations = {
	SET_USERS(state, data) {
		state.usersList = data;
	},
	SET_USERS_ACTA_ID(state, data){
		state.usersList = [data];
	},
	SET_USER_GROUPS(state, data) {
		state.usersGroupsList = data;
	},
	SET_USER_NEW_GROUPS(state, data){
		state.newGroups =  data
	},	
	UNSET_USER_NEW_GROUPS(state){
		state.newGroups = []
	},	
	SET_ASSIGN_GROUP_TO_EDIT (state, data) {
	const assignGroup = JSON.parse(JSON.stringify(data))
	state.groupAssignment = {
		...state.groupAssignment,
		...assignGroup
	}
	},
	SET_CURRENT_PAGE (state, data) {
    state.current_page = data
  },
  	SET_TOTAL_PAGE (state, data) {
    state.totalPages = data
  },
}

export default mutations



// WEBPACK FOOTER //
// ./src/store/modules/user_management/mutations.js